<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, inject, defineProps } from 'vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    icon: {
        type: String,
        required: true
    },
    color: {
        type: String,
        default: '#1976d2'
    },
    text: {
        type: String,
        default: ''
    },
    click: {
        type: Function,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

/*==================================================================*/
/*================== LOADING =======================================*/
/*==================================================================*/

const loading = ref(false);

/*==================================================================*/
/*================== INJECT ALTERA DISABLE =========================*/
/*==================================================================*/

const alteraDisable = inject('alteraDisable', null);

/*==================================================================*/
/*================== AO CLICAR =====================================*/
/*==================================================================*/

const aoClicar = async () => {

    loading.value = true;
    alteraDisable?.(true);

    try{

        await props.click();

    } finally{

        loading.value = false;
        alteraDisable?.(false);

    }

};

</script>

<template>

    <v-tooltip bottom>

        <template v-slot:activator="{ on, attrs }">
            
            <v-btn
                class="c-botao mx-2"
                fab
                dark
                small
                :color="props.color"
                :style="{ '--botao-cor': props.color }"
                v-bind="attrs"
                v-on="on"
                @click="aoClicar"
                :disabled="props.disabled"
                :loading="loading"
                :title="text"
            >
                <v-icon dark>
                    {{ icon }}
                </v-icon>
            </v-btn>

        </template>

        <span>{{ text }}</span>
        
    </v-tooltip>

</template>

<style scoped>

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao {
    background: var(--botao-cor) !important;
    border-color: var(--botao-cor) !important;
}

</style>
